import { CREATE_OFFERS_START } from "../../types";

export const create_offers = (payload) => ({
  type: CREATE_OFFERS_START,
  payload,
});
